import { number, string } from 'prop-types';
import React from 'react';
import { colors } from '@ajaibid/components';

const IconClock = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 3C5.68629 3 3 5.68629 3 9C3 12.3137 5.68629 15 9 15C12.3137 15 15 12.3137 15 9C15 5.68629 12.3137 3 9 3ZM1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 6C9.41421 6 9.75 6.33579 9.75 6.75L9.75 9.32536L11.2609 10.2319C11.6161 10.445 11.7312 10.9057 11.5181 11.2609C11.305 11.6161 10.8443 11.7312 10.4891 11.5181L8.61413 10.3931C8.38822 10.2576 8.25 10.0134 8.25 9.75L8.25 6.75C8.25 6.33579 8.58579 6 9 6Z"
      fill={color}
    />
  </svg>
);

IconClock.propTypes = {
  color: string,
  size: number,
};

IconClock.defaultProps = {
  color: colors.AJAIB_BLUE_5,
  size: 18,
};

export default IconClock;
